import { render, staticRenderFns } from "./CompoundQuestionType.vue?vue&type=template&id=82c7b588&scoped=true"
import script from "./CompoundQuestionType.vue?vue&type=script&lang=js"
export * from "./CompoundQuestionType.vue?vue&type=script&lang=js"
import style0 from "./CompoundQuestionType.vue?vue&type=style&index=0&id=82c7b588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c7b588",
  null
  
)

export default component.exports